"use client";
import { Children, PropsWithChildren, useEffect, useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";

import Box from "@mui/material/Box";

interface CarouselProps extends PropsWithChildren {}
const Carousel: React.FC<CarouselProps> = ({ children }) => {
	const swiperRef = useRef<SwiperType>();

	useEffect(() => {
		const handleUpdateSwiper = () => {
			swiperRef.current?.update();
		};
		window.addEventListener("resize", handleUpdateSwiper);
		return () => {
			window.removeEventListener("resize", handleUpdateSwiper);
		};
	}, []);

	return (
		<Box component="div" className="relative explore-carousel">
			<Swiper
				slidesPerView="auto"
				spaceBetween={16}
				observer={true}
				observeParents={true}
				breakpoints={{
					640: { spaceBetween: 16 },
					900: { spaceBetween: 24 },
				}}
				modules={[Navigation]}
				onSwiper={(swiper) => {
					swiperRef.current = swiper;
				}}
				className="!overflow-visible"
			>
				{Children.map(children, (child, _index) => (
					<SwiperSlide key={_index} className="w-full max-w-[270px] h-auto">
						{child}
					</SwiperSlide>
				))}
			</Swiper>
		</Box>
	);
};
export default Carousel;
